// extracted by mini-css-extract-plugin
export default {"image_box":"RenderFile_image_box__wJHtE","pdfView":"RenderFile_pdfView__psHpn","pdf_box":"RenderFile_pdf_box__6hFc1"};